import { Link, NavLink, Outlet } from 'react-router-dom'
import { useAuth } from '@/lib/auth-context'
import { Button } from '@/components/ui/button'
import { LayoutDashboard, Film, ListVideo, UploadCloud, Settings2, FileSignature, LogOut } from 'lucide-react'

const navItems = [
  { to: '/creator', label: 'Overview', icon: LayoutDashboard, end: true },
  { to: '/creator/series', label: 'Series', icon: Film },
  { to: '/creator/episodes', label: 'Episodes', icon: ListVideo },
  { to: '/creator/upload', label: 'Upload', icon: UploadCloud },
  { to: '/creator/agreement', label: 'Creator Agreement', icon: FileSignature },
  { to: '/creator/settings', label: 'Settings', icon: Settings2 },
]

export function CreatorLayout() {
  const { user, logout } = useAuth()

  return (
    <div className="min-h-screen bg-black text-white flex">
      <aside className="hidden md:flex w-64 flex-col border-right border-gray-900 bg-gradient-to-b from-black to-[#050309] border-r">
        <div className="px-6 py-6 border-b border-gray-900">
          <Link to="/" className="flex items-center gap-2">
            <img src="/img/logo.png" alt="Binyuma TV" className="w-8 h-8 object-contain" />
            <div>
              <p className="text-sm font-semibold tracking-wide">Binyuma TV</p>
              <p className="text-[11px] text-gray-500 uppercase tracking-widest">Studio</p>
            </div>
          </Link>
        </div>
        <nav className="flex-1 px-3 py-4 space-y-1">
          {navItems.map((item) => {
            const Icon = item.icon
            return (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                    isActive
                      ? 'bg-[#D4AF37]/15 text-[#D4AF37]'
                      : 'text-gray-400 hover:text-white hover:bg-white/5'
                  }`
                }
              >
                <Icon className="w-4 h-4" />
                <span>{item.label}</span>
              </NavLink>
            )
          })}
        </nav>
        <div className="px-4 py-4 border-t border-gray-900 space-y-2 text-xs text-gray-400">
          {user && (
            <div className="truncate">
              <p className="text-[11px] uppercase tracking-widest text-gray-500">Creator</p>
              <p className="text-sm truncate">{user.email}</p>
            </div>
          )}
          <Button
            variant="secondary"
            size="sm"
            className="w-full border-gray-800 text-gray-300 hover:bg-white/5"
            onClick={() => logout()}
          >
            <LogOut className="w-4 h-4 mr-2" />
            Sign out
          </Button>
        </div>
      </aside>

      <div className="flex-1 flex flex-col">
        <header className="md:hidden px-4 py-3 border-b border-gray-900 flex items-center justify-between bg-black/80 backdrop-blur">
          <Link to="/" className="flex items-center gap-2">
            <img src="/img/logo.png" alt="Binyuma TV" className="w-7 h-7 object-contain" />
            <span className="text-sm font-semibold tracking-wide">Binyuma Studio</span>
          </Link>
          {user && (
            <span className="inline-flex items-center rounded-full bg-[#D4AF37]/10 px-2 py-0.5 text-[11px] font-medium text-[#D4AF37]">
              Creator
            </span>
          )}
        </header>
        <main className="flex-1 bg-gradient-to-b from-black via-[#050309] to-black">
          <div className="max-w-6xl mx-auto px-4 py-6 md:px-8 md:py-8">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  )
}

